import {Field, Footer, FormRoot, Header, Error} from "../../auth/Form/Form";
import {TFormComponent} from "../../auth/Form/types";

export const Form = Object.assign(FormRoot, {
    Header: Header,
    Field: Field,
    Footer: Footer,
    Error: Error,
}) as TFormComponent